var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GCC/Checkbox Only"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Checkbox",
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 1,
    fill: "white",
    stroke: "#2C2C2C",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCheckedIcon);
export default __webpack_public_path__ + "static/media/UnCheckedIcon.f74fc78888070b026703bc45aa71bc0f.svg";
export { ForwardRef as ReactComponent };